"use client";
import React, { useState } from "react";
import Image from "next/image";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  // Toggle the Read More state
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  return (
    <>
      <div
        className={`${isReadMore ? "line-clamp-5" : ""} overflow-hidden`}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }}
      >
        {text}
      </div>
      {text.length > 380 && (
        <div
          onClick={toggleReadMore}
          className="style-redmore"
          style={{
            color: "#D5AF34",
            fontSize: "17px",
            display: "inline-block",
            marginLeft: "1px",
            cursor: "pointer",
          }}
        >
          {isReadMore ? "Read More" : "Show less"}
        </div>
      )}
    </>
  );
};

const section2 = ({ Mydata }) => {
  const data = Mydata?.[4];
  console.log(data, "");
  return (
    <div className="mb-10 ">
      <div className="mx-auto px-6 pt-10 max-w-7xl">
        <div className=" grid grid-cols-5 lg:gap-10">
          <div className="flex-auto col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-2">
            <div id="visionh2" className=" md:pt-3 lg:pt-3">
              <Image
                src={data?.image}
                height={400}
                width={1200}
                title={data?.tle}
                alt={data?.alt}
         
              />
            </div>
          </div>

          <div className="mb-4 col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-3">
            <h2 className="mt-4 text-4xl secondary font-bold">
              <span>{data?.subtitle}</span>{" "}
              <span className="text-[#D5AF34]">{data?.title}</span>
            </h2>

            <div className="">
              <p
                dangerouslySetInnerHTML={{ __html: data?.des }}
                className="updatedparapremu pt-6"
              ></p>
            </div>
          </div>

          {/* <div className=" col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-3">
        <h2 id="visionh2" className="text-4xl secondary font-bold">
          <span>{data.title1}</span>{" "}
          <span>{data.subtitle1}</span>
        </h2>

        <div className="">
          <p
            dangerouslySetInnerHTML={{ __html: data.des1 }}
            className="updatedparapremu pt-6"
          ></p>
        </div>
      </div>

      <div className="display  col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-2 lg:mt-0 md:mt-5 sm:mt-0 md:flex md:flex-col-reverse">
        <Image src={data.image1} height={400} width={1200} alt={data.alt1} />
      </div> */}
        </div>
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center lg:gap-x-8">
          <div className="mt-4 lg:col-span-7 lg:mt-7 xl:col-span-7">
            <h2 className="text-4xl secondary font-bold">
              <span>{data?.subtitle1}</span>
              {""}
              <span className="text-[#D5AF34]">{data?.title1}</span>{" "}
            </h2>
            <div className="">
            <p
                dangerouslySetInnerHTML={{ __html: data?.des1 }}
                className="updatedparapremu pt-6"
              ></p>
            </div>
          </div>
          <div className="flex-auto col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-5">
            <div id="visionh2" className=" md:pt-3 lg:pt-3">
              <Image
                src={data?.image1}
                height={400}
                width={1200}
                title={data?.tle}
                alt={data?.alt1}
              
              />
            </div>
          </div>
        </div>

        {/* -====================== */}
        <div className=" lg:grid lg:grid-cols-12 lg:items-center lg:gap-x-8">
          <div className="flex-auto col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-5">
            <div id="visionh2" className=" md:pt-3 lg:pt-3">
              <Image
                src={data?.image2}
                height={400}
                width={1200}
                title={data?.tle2}
                alt={data?.alt2}
              />
            </div>
          </div>
          <div className="mt-4 lg:col-span-7 lg:mt-7 xl:col-span-7">
            <h2 className="text-4xl secondary font-bold">
              <span>{data?.subtitle2}</span>
              {""}
              <span className="text-[#D5AF34]">{data?.title2}</span>{" "}
            </h2>
            <div className="">
              <p
                dangerouslySetInnerHTML={{ __html: data?.des2 }}
                className="updatedparapremu pt-6"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default section2;
